export default __webpack_public_path__ + "static/media/metamask-medium.4a01ad51.png";